import { ChangeDetectorRef, Directive } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Address, IAddressData } from '@df/session/api/address-book/address';
import { AddressBook } from '@df/session/api/address-book/address-book';
import { AbstractFormComponent } from '@df/ui/form/abstract-form.component';
import { Nexus } from '@tomandco/nexus-api-types';
import { ICallableObject } from '../../dragonfly-api/src/request/request.service';

@Directive()
export abstract class AccountAddressEditComponentDef extends AbstractFormComponent<IAddressData> {
    protected submitPath = Nexus.Api.Customer.SaveAddress.path;
    override redirect = '/account/address-book';

    model!: Address;

    get isNew(): boolean {
        return !this.model.id;
    }

    constructor(
        protected activatedRoute: ActivatedRoute,
        ref: ChangeDetectorRef,
        public addressBook: AddressBook
    ) {
        super(ref);
    }

    override reset(): void {
        const params = this.activatedRoute.snapshot.params;
        const id = params ? parseInt(params['id'], 10) : 0;
        const customerAddress: Address | undefined = this.addressBook.byId(id);
        this.model = this.addressBook.create(customerAddress ? { ...customerAddress.data } : { country_id: this.app.data.defaultCountry });
        this.data = this.model.data;
        this.ref.detectChanges();
    }

    override getSubmitAction(): ICallableObject<Partial<IAddressData>> {
        return {
            path: this.submitPath,
            data: {
                ...this.data,
                is_billing: this.data.is_billing || false,
                is_shipping: this.data.is_shipping || false
            }
        };
    }
}
